import { gql } from "@apollo/client";

import { fragments as OrderProductionJobDetailFragments } from "../../components/ProductionJobDetail/graph";

const addCustomizationAreaToOrderProductionJobMutation = gql`
  mutation(
    $autobase: Boolean!
    $colorCount: Int
    $colors: [InkPantoneColorInput!]!
    $customizationAreaTemplateId: ID!
    $distressed: Boolean!
    $flatten: Boolean!
    $halftones: Boolean!
    $imageRepair: Boolean!
    $note: String!
    $method: ProductCustomizationMethod!
    $orderProductionJobId: ID!
    $splitIntoColors: Boolean!
    $sponsorback: Boolean!
    $recreate: Boolean!
    $vinylConfiguration: VinylConfigurationInput
  ) {
    addCustomizationAreaToOrderProductionJob(
      autobase: $autobase
      colors: $colors
      colorCount: $colorCount
      customizationAreaTemplateId: $customizationAreaTemplateId
      distressed: $distressed
      flatten: $flatten
      halftones: $halftones
      imageRepair: $imageRepair
      note: $note
      method: $method
      orderProductionJobId: $orderProductionJobId
      splitIntoColors: $splitIntoColors
      sponsorback: $sponsorback
      recreate: $recreate
      vinylConfiguration: $vinylConfiguration
    ) {
      createdOrderProductionJobCustomizationArea {
        id
        orderProductionJob {
          id
          ...ProductionJobDetail_productionJob
        }
      }
      errors {
        autobase
        colorCount
        colors
        customizationAreaTemplateId
        distressed
        flatten
        halftones
        imageRepair
        method
        note
        orderProductionJobId
        recreate
        sponsorback
        vinylConfiguration
        vinylConfigurationInput {
          names
          namesColorId
          namesFontId
          numbers
          numbersColorId
          numbersFontId
          size
        }
      }
      succeeded
    }
  }
  ${OrderProductionJobDetailFragments.productionJob}
`;

export default addCustomizationAreaToOrderProductionJobMutation;
